import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface ModalFooterProps {
  columns?: number;
  sticky?: boolean;
  centerButtons?: boolean;
}

const ModalFooter = styled.footer<ModalFooterProps>`
  position: relative;
  bottom: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  gap: ${toRem(11)};
  justify-items: center;
  align-items: center;
  width: 100%;
  height: auto;
  padding-top: ${toRem(theme.modal.spacing.small)};

  > button {
    width: 100%;

    &:first-child {
      order: -1;
    }
  }

  ${({ centerButtons }) =>
    centerButtons &&
    css`
      display: flex;

      > button {
        width: auto;
      }
    `}

  @media (max-width: ${theme.breakpoint.small}px) {
    display: grid;

    > button {
      width: 100%;

      &:first-child {
        order: 1;
      }
    }
  }

  ${({ sticky }) =>
    sticky &&
    css`
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: ${theme.zIndex.modal + 3};
      align-items: flex-start;
      height: ${toRem(theme.modal.footer.height)};
      padding-top: ${toRem(theme.modal.spacing.large)};
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 36.12%);
    `}

  ${({ columns }) =>
    columns === 1
      ? css`
          grid-template-columns: 1fr;

          > button {
            width: auto;
          }

          > * {
            &:first-child {
              justify-self: auto;
            }

            &:last-child {
              justify-self: auto;
            }
          }
        `
      : css`
          grid-template-columns: 1fr;

          @media (min-width: ${theme.breakpoint.small}px) {
            grid-template-columns: repeat(${columns}, 1fr);
          }
        `}
`;

export default ModalFooter;
